import script from "./certificate.vue?vue&type=script&setup=true&lang=js"
export * from "./certificate.vue?vue&type=script&setup=true&lang=js"

import "./certificate.vue?vue&type=style&index=0&id=7e23113a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e23113a"]])

export default __exports__